import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./BlogDetail.css";
import { fetchAPI } from "../utils/api";

import anjana from "../assets/images/anjana.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import BlogData from "../layout/BlogData";
import { Link } from "react-router-dom";
import { ShimmerTitle, ShimmerText, ShimmerThumbnail } from "react-shimmer-effects";

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchAPI(`blog-detail/${slug}`)
      .then((res) => {
        if (res.status === 200 && res.result) {
          setBlog(res.result);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching blog details:", err);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="container my-5 py-3">
          <ShimmerTitle line={2} gap={10} variant="heading" />
          <div className="my-4">
            <ShimmerThumbnail height={350} rounded />
          </div>
          <ShimmerText line={8} gap={12} />
        </div>
        <Footer />
      </>
    );
  }

  if (!blog) {
    return (
      <>
        <Header />
        <div className="blog_detail_main text-center py-5">
          <h3>Blog Not Found</h3>
          <p>
            The blog post you are looking for does not exist or has been
            removed.
          </p>
        </div>
        <Footer />
      </>
    );
  }

  const formattedDate = new Date(blog.blog_created).toLocaleDateString(
    "en-GB",
    {
      day: "numeric",
      month: "long",
      year: "numeric",
    },
  );

  return (
    <>
      <Header />
      <div className="blog_detail_main">
        <div className="container">
          <div className="inner_detail">
            <div className="date_text_detail">
              <p>Health Care</p>
              <span>{formattedDate}</span>
            </div>

            <h1 className="main_heading_detail">{blog.blog_title}</h1>

            <div className="detail_img">
              <img src={blog.blog_image} alt={blog.blog_title} />
            </div>

            <div
              className="blog_content_body dynamic-blog-content"
              dangerouslySetInnerHTML={{ __html: blog.blog_description }}
            />
          </div>
        </div>
{/* 
        <div className="blog-comments-section">
          <div className="container">
            <h3>Comments</h3>

            <div className="comments-main">
              <div className="comment-img">
                <img src={anjana} alt="detail-img-1" className="img-fluid" />
              </div>
              <div className="comment-content">
                <h4>
                  Monica <span>. 2 days ago</span>
                </h4>
                <p>
                  Ventilators-aids to help a patient breathe when they cannot-
                  are life-supporting devices. They put in oxygen to the lungs
                  and suck out the carbon dioxide, to maintain the oxygen
                  saturation. These ventilators are of utmost importance in
                  tackling issues of respiratory failure, acute pneumonia
                </p>
              </div>
            </div>

            <div className="comments-main">
              <div className="comment-img">
                <img src={anjana} alt="detail-img-1" className="img-fluid" />
              </div>
              <div className="comment-content">
                <h4>
                  Monica <span>. 2 days ago</span>
                </h4>
                <p>
                  Ventilators-aids to help a patient breathe when they cannot-
                  are life-supporting devices. They put in oxygen to the lungs
                  and suck out the carbon dioxide, to maintain the oxygen
                  saturation. These ventilators are of utmost importance in
                  tackling issues of respiratory failure, acute pneumonia
                </p>
              </div>
            </div>

            <div className="comments-main">
              <div className="comment-img">
                <img src={anjana} alt="detail-img-1" className="img-fluid" />
              </div>
              <div className="comment-content">
                <h4>
                  Monica <span>. 2 days ago</span>
                </h4>
                <p>
                  Ventilators-aids to help a patient breathe when they cannot-
                  are life-supporting devices. They put in oxygen to the lungs
                  and suck out the carbon dioxide, to maintain the oxygen
                  saturation. These ventilators are of utmost importance in
                  tackling issues of respiratory failure, acute pneumonia
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="form_detail_page">
          <div className="container">
            <div className="inner_form_detail">
              <h4>Leave A Comment</h4>
              <p>
                Your email address will not be published. Required fields are
                marked *
              </p>
              <div className="main_form_detail">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" name="name" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control" name="email" />
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label">Comment</label>
                    <textarea
                      className="form-control"
                      name="comment"
                      rows="5"
                    ></textarea>
                  </div>

                  <div className="col-12">
                    <button type="submit" className="btn btn-primary">
                      Post Comment
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>


      <div className="container">
        <div className="relevent-blogs-slider">
          <h3 className="title">Relevent Blogs</h3>

          <div className="slider-wrapper">
            <Swiper
              modules={[Autoplay, Navigation]}
              spaceBetween={30}
              slidesPerView={4}
              loop={true}
              autoplay={{ delay: 5500, disableOnInteraction: false }}
              navigation
              pagination={{ clickable: true }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 5,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 5,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 15,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                },
              }}
            >
              {BlogData.map((blog) => (
                <SwiperSlide>
                  <div key={blog.id}>
                    <div className="blogs_main_box">
                      <img src={blog.image} alt={blog.title} />
                      <div className="date-text">
                        <p>{blog.author}</p>
                        <span>{blog.date}</span>
                      </div>
                      <h3>{blog.title}</h3>
                      <p>{blog.description}</p>
                      <div className="detail_link">
                        <Link to={`/blog/${blog.slug || blog.id}`}>Read More...</Link>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
